export default __webpack_public_path__ + "static/about_girl-f67d39f714b799ee666cb0d5174c9b79.png";